export class RestEndPoints {

  public static URL_SEPARATER = '/';

  public static GET_DOMAIN: string = '/domain';
  public static GET_DOMAIN_BY_ID: string = '/domains';
  public static GET_DOMAIN_OPEN_CHANGE_REQUESTS_BY_ID: string = '/opencr';
  public static GET_DOMAIN_DIFF: string = '/domains/changediff';
  public static GET_DIFF_AND_SPLIT: string = '/domains/splitAndDiff';
  public static COMMON_COMMAND: string = '/staff/command';
  public static RESET_PASSWORD: string = '/resetPassword';
  public static RECOVER_USERNAME: string = '/recoverUserName';

  public static GET_CHANGE_REQUESTS: string = '/change-requests';
  public static GET_LIST_OF_DOMAINS: string = '/domains';
  public static GET_CHANGE_REQUEST_DETAILS: string = '/change-requests/';
  public static AC_TC_CONFIRMATION: string = '/change-requests/contact-confirmation';
  public static GET_TLD_MANAGER_USER_BY_EMAIL: string = '/tldManagerUserByEmail/';

  public static GET_USER_AUDIT_LOG: string = '/audit';
  public static GET_CURRENT_USER_AUDIT_LOG: string = "/currentUserAuditLog";
  public static GET_USER_LOGIN_ACTIVITY: string = '/loginHistory/';
  public static USERS: string = '/users/';
  public static GET_USER_BY_ID: string = '/users/';
  public static GET_CURRENT_USER_UNAUTHENTICATED_REQUEST: string = '/getCurrentUserFromHeader';
  public static GET_CURRENT_USER: string = '/currentUser';
}
